module.exports = __webpack_public_path__ + "static/img/31.4894333c.gif";